import {Component} from "@angular/core";
import {HeaderComponent} from "../../layout/header/header.component";
import {LargeLogoShearComponent} from "../../layout/large-logo-shear/large-logo-shear.component";

@Component({
  selector: "app-disclaimer",
  templateUrl: "./disclaimer.component.html",
  imports: [
    HeaderComponent,
    LargeLogoShearComponent,
  ],
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class DisclaimerComponent {
}
